var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"2274 741 5 8.5"}},[_c('path',{attrs:{"d":"M2274.322 742.347l3.016 3.027-3.016 3.027a.573.573 0 1 0 .81.811l3.428-3.427a.57.57 0 0 0 0-.81l-3.427-3.428a.573.573 0 1 0-.811.811z","data-name":"Groupe 296"}})])};var toString = function () {return "/builds/agoulay/GUI-drivers/src/assets/svg/icon-chevron-right.svg"};module.exports = { render: render, toString: toString };


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/icon-chevron-right.svg
// module id = 6Qqk
// module chunks = 2